import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { isBranchSession } from '../auth-session.util';

/**
 * BR-59: pages that only an HQ office may open.
 *
 * `/branches` and `/offices/settings` carried only `authGuard`, so a
 * branch-role session could reach branch management and office settings simply
 * by typing the URL — the nav merely HIDES those entries for that role. The
 * backend does scope the writes, so this is UI exposure rather than privilege
 * escalation, but a leaf should not be able to open the page that manages its
 * own siblings.
 */
export const hqOnlyGuard: CanActivateFn = () => {
  if (!isBranchSession()) {
    return true;
  }
  // VENDOR-1: bounce to the landing page. A branch session may open it — the
  // dashboard carries no `hqOnlyGuard` — so this cannot loop.
  return inject(Router).createUrlTree(['/dashboard']);
};
